;(function () {
    function SearchFilterForm(form) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.submitOnCheckboxClick()
        }

        this.submitOnCheckboxClick = function () {
            const checkboxes = $(form).find('[rel="search-filters--bucket"] :checkbox')
            checkboxes.toArray().forEach(function (checkbox) {
                $(checkbox).click(function () {
                    form.submit()
                })
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.SearchFilterForm = window.SearchFilterForm || {}

    window.SearchFilterForm.SearchFilterForm = SearchFilterForm
})()

$(document).ready(function () {
    const form = $('[rel="search-filters"]').find('form')

    if (form) {
        new window.SearchFilterForm.SearchFilterForm(form)
    }
})
